/* eslint-disable no-console */

import { register } from 'register-service-worker'
import store from './store'

// skipWaiting: true → SW ใหม่ activate เอง แต่ JS ที่รันอยู่ยังเป็นตัวเก่า
// รอให้ SW ใหม่ activated จริงก่อนค่อยโชว์ปุ่ม เพื่อให้ reload แล้วได้เวอร์ชันใหม่แน่นอน
// (เคยใช้ skipWaiting: false + SKIP_WAITING แล้วติด: refresh ธรรมดายังได้ SW เก่าที่ไม่มีปุ่ม)
function notifyWhenActivated(registration) {
    const worker = registration.waiting || registration.installing || registration.active
    const notify = () => store.commit('pwa/SET_UPDATE_AVAILABLE', true)

    if (!worker || worker.state === 'activated') {
        notify()
        return
    }
    worker.addEventListener('statechange', () => {
        if (worker.state === 'activated') notify()
    })
}

if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            console.log(
                'App is being served from cache by a service worker.\n' +
                'For more details, visit https://goo.gl/AFskqB'
            )
        },
        registered() {
            console.log('Service worker has been registered.')
        },
        cached() {
            console.log('Content has been cached for offline use.')
        },
        updatefound() {
            console.log('New content is downloading.')
        },
        // ถูกเรียกเมื่อ SW ใหม่ติดตั้งเสร็จ (installed) ระหว่างที่หน้านี้เปิดอยู่
        updated(registration) {
            console.log('New content is available; please refresh.')
            notifyWhenActivated(registration)
        },
        offline() {
            console.log('No internet connection found. App is running in offline mode.')
        },
        error(error) {
            console.error('Error during service worker registration:', error)
        }
    })
}

// หน้าแรกเรียกตอนเปิด → ให้ browser เช็ค service-worker.js บน server; ถ้ามีเวอร์ชันใหม่จะไปจบที่ updated() ข้างบน
export function checkForUpdate() {
    if (!('serviceWorker' in navigator)) return Promise.resolve()

    return navigator.serviceWorker.getRegistration()
        .then(registration => registration && registration.update())
        .catch(error => console.log(error))   // offline / server error = ข้ามไป ไม่ต้องแจ้งผู้ใช้
}

// ผู้ใช้กด "Kemas kini" → SW ใหม่ activated แล้ว แค่ reload ก็ได้ index.html + JS ชุดใหม่จาก precache
export function applyUpdate() {
    window.location.reload()
}
